import { render, staticRenderFns } from "./tehbimVideo.vue?vue&type=template&id=66d67576&scoped=true&"
import script from "./tehbimVideo.vue?vue&type=script&lang=js&"
export * from "./tehbimVideo.vue?vue&type=script&lang=js&"
import style0 from "./tehbimVideo.vue?vue&type=style&index=0&id=66d67576&scoped=true&lang=css&"
import style1 from "./tehbimVideo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d67576",
  null
  
)

export default component.exports